import { ArrowCounterClockwise } from "@phosphor-icons/react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import { Button } from "common/components/ui/Button";

import NoResultsImage from "assets/images/empty-placeholders/result-not-found.png";
import InitialPlaceholderImage from "assets/images/empty-placeholders/source-initial-placeholder.png";

interface SearchAndFiltersEmptyPlaceholderProps {
  hasFilters: boolean;
  hasSearch: boolean;
  onClearAll: () => void;
  initialActionComponent?: JSX.Element;
}

export default function SearchAndFiltersEmptyPlaceholder({
  hasFilters,
  hasSearch,
  onClearAll,
  initialActionComponent,
}: SearchAndFiltersEmptyPlaceholderProps) {
  let imageSrc = InitialPlaceholderImage;
  let title = "Apply filters to find leads";
  let subtitle = "Leads matching your search criteria will be displayed here";
  let actionComponent = initialActionComponent;

  if (hasSearch || hasFilters) {
    let buttonText: string;
    imageSrc = NoResultsImage;

    if (hasSearch && hasFilters) {
      title = "No results found matching your criteria";
      subtitle = "Change your filters or search criteria and try again";
      buttonText = "Clear all";
    } else if (hasSearch) {
      // the search criteria returned nothing
      title = "No results found for your search";
      subtitle = "Change your search criteria and try again";
      buttonText = "Clear search";
    } else if (hasFilters) {
      // the results are on another page
      title = "No results found for the selected filters";
      subtitle = "Change your filters and try again";
      buttonText = "Clear filters";
    }

    actionComponent = (
      <Button
        onClick={onClearAll}
        leftIcon={<ArrowCounterClockwise />}
        variant="secondary-black"
      >
        {buttonText}
      </Button>
    );
  }

  return (
    <EmptyPlaceholder
      imageSrc={imageSrc}
      title={title}
      subtitle={subtitle}
      actionComponent={actionComponent}
    />
  );
}
